import getCookie from "./getCookie";

export const conversionApi = async (sessionInfo, planInfo, email) => {
  if(!sessionInfo) return;
  // Dev and test builds send nothing to the production Meta pixel (index.html, issue #25).
  if (window.isTestFlow) return;
  const { subscription, customer } = sessionInfo;
  if(!subscription || !customer) return console.error('conversionApi: No data available on the subscription or the purchaser.')
  const userEmail = email || customer.email;

  const localStorageKey = `conversion_sent_${userEmail}_${planInfo.title}`;

  if (localStorage.getItem(localStorageKey)) return;

  let formData = new FormData();
  const fbc = getCookie('_fbc');
  const fbp = getCookie('_fbp');
  const period = planInfo.period;
  const plan = planInfo.title;
  const currency = subscription.currency;
  const discounted = `${planInfo.salePrice / 100}`;
  const subscriptionPrice = `${planInfo.fullPrice / 100}`
  formData.append('email', userEmail);
  formData.append('period', period);
  formData.append('currency', currency);
  formData.append('discounted', discounted);
  formData.append('subscription', subscriptionPrice);
  formData.append('plan', plan);
  formData.append('fbc', fbc);
  formData.append('fbp', fbp);

  try {
    const response = await fetch('/api/conversion-api.php', {
      method: 'POST',
      body: formData,
    });
    const result = await response.json();

    if (response.ok) {
      // Успешно — записываем в localStorage
      localStorage.setItem(localStorageKey, 'sent');
    } else {
      console.error('conversionApi: The server encountered an error.', result);
    }
    console.log(result);
    return result;
  } catch (error) {
    console.error('conversionApi: request error', error);
    return { error: error.message };
  } finally {
    localStorage.setItem(localStorageKey, 'sent');
  }
};
